<template>
    <div class="ml-4">
        <h1 class="text-muted mb-4">
            <vue-fontawesome class="mr-2" icon="credit-card"></vue-fontawesome>        
            <router-link class="ml-2 text-decoration-none"
                to="/sales">
                <i class="ml-2 arrow left" style="height:25px;width:25px"></i>
                Sales
            </router-link>   
            / {{sale_details.id}}
        </h1>        
        <div>        
            <div class="" v-if="sale_details">
                <div class="modal-header border-0">
                    <h5 class="modal-title font-weight-bold" >Receipt No. {{sale_details.id}}</h5>    
                    <button type="button" class="btn btn-success" data-dismiss="modal" @click="printReceipt()">Print receipt</button>
                </div>
                <div class="modal-body">								
                    <div class="d-flex justify-content-between">
                        <!-- deatils -->
                        <section class="p-3" style="border-right: solid 1px darkgray ; min-width: 200px;">										
                            <span class="d-flex flex-column">
                                <label class="font-weight-bold">Date:</label>										
                                <p class="ml-2">{{sale_details.date | dateformat}}</p>
                            </span>
                            <span class="d-flex flex-column">
                                <label class="font-weight-bold">Order Number:</label>
                                <span class="ml-2">{{sale_details.orderNumber}}</span>
                            </span>
                            <span class="d-flex flex-column">
                                <label class="font-weight-bold">Customer:</label>
                                <span class="ml-2">{{sale_details.customerId}}</span>
                            </span>
                            <span class="d-flex flex-column">
                                <label class="font-weight-bold">Via</label>
                                <span class="ml-2">{{sale_details.via}}</span>
                            </span>																			
                        </section>
                        <!-- Items sold and payments -->
                        <section class="p-3 d-flex justify-content-center flex-wrap" style="height:50vh; overflow-y:scroll">										
                            <!-- items sold -->
                            <div class="table-responsive">
                                <h3 class="text-muted">Items sold</h3>
                                <table class="table table-borderless">													
                                    <thead>
                                        <tr>												
                                        <th scope="col">Product</th>                                        
                                        <th scope="col">Qty</th>												
                                        <th scope="col">Price</th>
                                        <th>subtotal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(product,index) in sale_details.products" :key="index">												
                                            <td>{{product.name}}</td>                                            
                                            <td>{{product.qty}}</td>
                                            <td>{{product.total | intcomma}}</td>
                                            <td>{{(product.total * product.qty) | intcomma}}</td>
                                            <td>
                                                <button class="btn btn-sm btn-outline-success" 
                                                    data-toggle="modal" data-target="#returnItemModal"
                                                    @click="setItem(product)">
                                                    <vue-fontawesome class="mr-2" icon="undo"></vue-fontawesome>
                                                    Return
                                                </button>
                                            </td>
                                        </tr>												
                                    </tbody>
                                </table>
                            </div>	
                            <!-- payments-->
                            <div class="table-responsive">
                                    <h3 class="text-muted">Payments</h3>
                                    <table class="table table-borderless">													
                                        <thead>
                                            <tr>																										
                                            <th scope="col">Type</th>
                                            <th scope="col">Transaction Id</th>
                                            <th scope="col">Amount</th>																										
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(payment,index) in sale_details.payments" :key="index">																											
                                                <td>{{payment.type}}</td>
                                                <td>{{payment.transaction_id}}</td>
                                                <td>{{payment.amount | intcomma}}</td>															
                                            </tr>												
                                        </tbody>
                                    </table>
                            </div>
                            <!-- Returns-->
                            <div v-if="sale_details.returns.length" class="table-responsive">
                                <h3 class="text-muted">Returns</h3>
                                <table class="table table-borderless">													
                                    <thead>
                                        <tr>																										
                                        <th scope="col">Product</th>
                                        <th scope="col">State</th>
                                        <th scope="col">Quantity</th>																										
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(_return,index) in sale_details.returns" :key="index">																											
                                            <td>{{_return.product_name}}</td>
                                            <td>{{_return.state}}</td>
                                            <td>{{_return.quantity | intcomma}}</td>															
                                        </tr>												
                                    </tbody>
                                </table>
                        </div>										
                        </section>

                        <div></div>
                    </div>
                </div>
                <div class="modal-footer border-0">
                        <span class="d-flex justify-content-between">
                            <label class="font-weight-bold">Items:</label>
                            <span class="ml-2">{{totalItems(sale_details.products) | intcomma}}</span>
                        </span>	
                        <span class="d-flex justify-content-between">
                            <label class="font-weight-bold">Total cost:</label>
                            <span class="ml-2">{{totalCost(sale_details.products) | intcomma}}</span>
                        </span>
                        <span class="d-flex justify-content-between">
                            <label class="font-weight-bold">Total payed:</label>											
                            <span class="ml-2">{{totalPayment(sale_details.payments) | intcomma}}</span>
                        </span>
                </div>
            </div>
    </div>
    <!-- modals -->
    <div>
        <!-- return sale Modal -->
        <div class="modal fade" id="returnItemModal" tabindex="-1" role="dialog" aria-labelledby="returnItemModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                <h5 v-if="item_to_return" class="modal-title" id="exampleModalLabel">Return {{item_to_return.name}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                </div>
                <div class="modal-body">            
                    <div class="p-3 d-flex justify-content-between">
                        <label class="font-weight-bold">Quantity</label>
                        <input type="number" class="col-8 form-control" v-model="return_qty">
                    </div> 
                    <div class="p-3 d-flex justify-content-between">
                        <label class="font-weight-bold">Condition</label>
                        <select class="form-control col-8" v-model="return_condition">
                            <option value="S">Good</option>
                            <option value="D">Bad</option>
                        </select>
                    </div> 
                </div>
                <div class="modal-footer">
                <button type="button" id="closeReturnModalButton" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" @click="returnItems()" class="btn btn-success">
                    Return Item
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="adding"></span>
                </button>
                </div>
            </div>
            </div>
        </div>
        <!-- printable receipt modal -->
        <div class="modal fade" id="printModal" tabindex="-1" role="dialog" aria-labelledby="printModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">printable receipt</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                </div>
                <div class="modal-body">
                    <!-- ticket -->
                    <div id="receipt-el" v-if="sale_details">
                        <div class="ticket">
                            <div class="d-flex justify-content-center">
                                <img style="width: 40px; height: auto;" src="@/assets/logo.png" alt="">
                            </div>
                            <p class="centered">VIDDUKA
                                <br>DATE: {{sale_details.date | dateformat}}
                                <br>ORDER: {{sale_details.orderNumber}}
                            </p>
                            <table class="receipt">										
                                <thead class="receipt">
                                    <tr class="receipt">
                                        <th class="receipt">Name</th>
                                        <th class="receipt quantity">Q.</th>
                                        <th class="receipt description">price</th>
                                        <th class="receipt price">Total</th>
                                    </tr>
                                </thead>
                                <tbody class="receipt">
                                    <tr class="receipt" v-for="(product,index) in sale_details.products" :key="index">
                                        <td class="receipt">{{product.name}}</td>
                                        <td class="receipt quantity">{{product.qty}}</td>											
                                        <td class="receipt price">{{product.total | intcomma}}</td>
                                        <td class="receipt">{{(product.total * product.qty) | intcomma}}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">TOTAL</td>												
                                        <td></td>
                                        <td></td>
                                        <td class="font-weight-bold">{{totalPrice(sale_details.products) | intcomma }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <hr>
                            <div class="centered">
                                <p>PAYMENTS</p>
                                <table class="receipt">													
                                    <thead class="receipt">
                                        <tr class="receipt">																										
                                            <th scope="col">Type</th>
                                            <th scope="col">Transaction Id</th>
                                            <th scope="col">Amount</th>																										
                                            </tr>
                                    </thead>
                                    <tbody class="receipt">
                                        <tr v-for="(payment,index) in sale_details.payments" :key="index">																											
                                            <td>{{payment.type}}</td>
                                            <td>{{payment.transaction_id}}</td>
                                            <td>{{payment.amount | intcomma}}</td>															
                                        </tr>												
                                    </tbody>
                                </table>
                            </div>
                            <p class="centered">Thanks for your purchase!
                                <br>vidduka.com
                            </p>
                        </div>
                    </div> 
                </div>
                <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary">Save changes</button>
                </div>
            </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
export default {
    name: 'saleDetail',    
    data(){
        return{          
            adding: false,  
            sale_id : this.$route.params.sale_id,
            sale_details: null,
            item_to_return:null,
            return_qty: 1,
            return_condition: 'S',
        }
    },  
    mounted(){        
        this.getSaleDetails()
    },
    methods:{        		        
        //get sale details
        getSaleDetails: function(){
            this.$http({
                method:'get',
                url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/sale/${this.sale_id}`,
                headers:{
                    Authorization: JSON.parse(localStorage.getItem('auth_token'))
                },                
            }).then((response)=>{
                this.sale_details = response.data
            }).catch((err)=>{
                this.$emit('alert',err)
            })
        },
        setItem: function(item){
            this.item_to_return = item
        },
        totalItems: function(products){
			var total = 0
			for (var i in products){				
				total += parseInt(products[i].qty)
			}
			return total
		},
		totalCost: function(products){
			var total = 0.00
			for (var i in products){				
				total += parseFloat(products[i].total)
			}
			return total
		},
		totalPayment: function(payments){
			var total = 0.00
			for (var i in payments){
				total += parseFloat(payments[i].amount)
			}
			return total
		},
        totalPrice: function(products){	
            var total = 0.00
            for (var product of products){
                total += (product.total * product.qty)
            }
            return total
        },
        //make a return
        returnItems: function(){
            this.adding = true
			this.$http({
				method: 'post',
				url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/return/`,
				headers:{
					Authorization: JSON.parse(localStorage.getItem('auth_token'))
				},
				data:{
                    id: this.$randID(),
                    date: this.$moment().format('YYYY-MM-DDTHH:mm:ssZZ'),
                    sale_id: this.sale_id,
                    items:[
                        {
                            product_id: this.item_to_return.product_id,
                            quantity: this.return_qty,
                            product_name: this.item_to_return.name,
                            state: this.return_condition,
                            variant_id: ""
                        }
                    ]			
				}
			}).then(()=>{
				this.adding = false
                document.getElementById('closeReturnModalButton').click()
                this.$emit('success','Sale return made successfully')
                this.getSaleDetails()
			}).catch((err)=>{
				this.adding = false	
                console.log(err)			
				alert(err)
			})
        },
        //print_receipt.
        printReceipt: function(){
            var receipt = document.getElementById('receipt-el').innerHTML
            var a = window.open('', '', 'height=500, width=500');
            a.document.write('<html>');
            a.document.write('<body>');
            a.document.write(receipt);
            a.document.write('</body></html>');
            a.document.close();
            a.print();
        }
    }
}
</script>